import React, { useEffect, useState } from "react";

import { ReactComponent as ArrowBackIcon } from "assets/images/common/svgs/arrow_back.svg";
import editProfilePicUser from "assets/images/common/others/editProfileUSer.png";
import { useLocation, useNavigate } from "react-router-dom";
import EventOverview from "./component/EventOverview";
import EventDetail from "./component/EventDetail";
import EventMission from "./component/EventMission";
import Community from "./component/Community";
import useUtils from "hooks/useUtils";
import useUsers from "containers/user-management/useHooks";
import { concatPathWithBackendUrl } from "utils/helpers/urlHelper";


interface Tab {
  name: string;
  Component: JSX.Element;
}


const ViewMinorEventDetail = () => {

  const [event, setEvent] = useState<any>({});
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = location.state || {};
  console.log(user)
  const { getQueryParams } = useUtils();
  const params = getQueryParams();
  const { getEventDetailById } = useUsers();

  const tabs: Tab[] = [
    { name: "Overview", Component: <EventOverview eventData={event} /> },
    { name: "Details", Component: <EventDetail eventData={event} /> },
    { name: "Mission", Component: <EventMission eventData={event} /> },
    { name: "Community", Component: <Community eventId={event?.event?.id} /> },
  ];
  const [activeTab, setActiveTab] = useState<Tab>(tabs[0]);

  console.log(params?.id, user);
  useEffect(() => {
    getEventDetailById(params?.id, setEvent);
  }, []);
  console.log(event);

  const goToBack = () => {
    navigate(-1);
  };

  const attendingCount = event?.event?.eventSubscriptions?.length || 0;
  const renderAttendingCount = () => {
    if (!attendingCount || attendingCount <= 0) {
      return <span className="text-base text-lightBlackText ml-2"></span>;
    }

    if (attendingCount > 3) {
      return (
        <span className="text-base text-lightBlackText ml-3">3+ attendees</span>
      );
    }

    return (
      <span className="text-base text-lightBlackText ml-3">
        {attendingCount} {attendingCount === 1 ? "attendee" : "attendees"}
      </span>
    );
  };

  return (
    <div>
      <h1 className="text-base text-primaryText font-bold flex items-center gap-3">
        <span
          onClick={goToBack}
          className="bg-transparentBlueBg w-[44px] h-[44px] rounded-full flex items-center justify-center cursor-pointer"
        >
          <ArrowBackIcon />
        </span>
        {event?.event?.title || ""}
      </h1>

      <div className="bg-white border-[0.3px] border-mediumGrayBorder rounded-[20px] p-6 my-6">
        <div className="flex justify-start items-center gap-2 mb-4">
          <span>
            <img className="w-[82px] h-[82px] rounded-full" src={
              user?.user?.profilePicUrl
                ? concatPathWithBackendUrl(
                  user?.user?.profilePicUrl?.fileDownloadUri
                )
                : editProfilePicUser
            } />
          </span>
          <span>
            <h2 className="text-base whitespace-nowrap font-bold text-primaryText">
              {`${user?.user?.firstName} ${user?.user?.lastName}`}
            </h2>
            <p className="text-xs font-medium text-primaryText">
              {user?.profiles?.child?.attendee?.lastName} family
            </p>
          </span>
        </div>
        <div className="flex gap-4 items-center">
          <h1 className="text-[20px] md:text-[26px] lg:text-[32px] font-bold text-primaryText">
            {event?.event?.title || ""}
          </h1>
          <p className="bg-peachFadeBg text-darkYellowText text-sm font-medium rounded-md  px-2 py-1">
            {event?.event?.isSession ? "Session" : "Workshop"}
          </p>
          <p className="text-sm font-medium text-captionText">
          {event?.event?.availableSlots}{" "}
          {event?.event?.availableSlots <= 1 ? "Slot" : "Slots"} Available
          </p>
        </div>
        <div className="flex items-center gap-4 my-3">
          <div
            className={`flex items-center ${
              attendingCount > 0 ? "" : "cursor-default"
            }`}
          >
            {attendingCount > 0 &&
              event?.event?.eventSubscriptions
                ?.slice(0, 3)
                .map((avatar: any, index: number) => (
                  <img
                    key={index}
                    src={
                      avatar?.profilePicUrl?.fileDownloadUri
                        ? concatPathWithBackendUrl(
                            avatar.profilePicUrl.fileDownloadUri
                          )
                        : editProfilePicUser
                    }
                    alt="Attendee"
                    className="w-7 h-7 -mr-2 rounded-full border-2 border-white"
                  />
                ))}
            {renderAttendingCount()}
          </div>
        </div>
        <div className=" flex gap-8 mt-8">
          {tabs.map((tab) => (
            <button
              key={tab.name}
              className={`text-xs font-semibold pb-1 transition-colors duration-300 ${activeTab.name === tab.name
                ? "text-lightBlueColor border-b-2 border-lightBlueColor"
                : "text-mediumGrayText hover:text-lightBlueColor"
                }`}
              onClick={() => setActiveTab(tab)}
            >
              {tab.name}
            </button>
          ))}
        </div>
        <div className="mt-4">
          {activeTab.name === "Overview" ? (
            <EventOverview eventData={event} />
          ) : activeTab.name === "Details" ? (
            <EventDetail eventData={event} />
          ) : activeTab.name === "Mission" ? (
            <EventMission eventData={event} />
          ) : activeTab.name === "Community" ? (
            <Community eventId={event?.event?.id} />
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default ViewMinorEventDetail;
